/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SkillVersion, SkillVersion$inboundSchema } from "./skillversion.js";

/**
 * A page of immutable skill versions.
 */
export type ListSkillVersionsResult = {
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
  /**
   * The skill versions in this page.
   */
  versions: Array<SkillVersion>;
};

/** @internal */
export const ListSkillVersionsResult$inboundSchema: z.ZodMiniType<
  ListSkillVersionsResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    versions: z.array(SkillVersion$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSkillVersionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillVersionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillVersionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillVersionsResult' from JSON`,
  );
}
